/** Polling adaptativo enquanto o sync está em andamento. */
export const STORE_SYNC_POLLING = {
  initialMs: 5_000,
  maxMs: 30_000,
  backoffFactor: 1.5
} as const

/** Tempo máximo aguardando conclusão antes de tratar como timeout. */
export const STORE_SYNC_TIMEOUT_MS = 2 * 60 * 1_000

/** Duração do banner de sucesso após concluir a sincronização. */
export const STORE_SYNC_SUCCESS_BANNER_MS = 5_000

/** Cache de GET status quando idle (evita requests duplicadas no mount). */
export const STORE_SYNC_STATUS_TTL_MS = 60_000

/** Progresso visual quando o status real demora a mudar. */
export const STORE_SYNC_FAKE_PROGRESS = {
  /** Percentual máximo antes da conclusão real. */
  maxPercent: 92,
  /** Percentual inicial ao iniciar o sync (evita barra parada em 0%). */
  initialPercent: 8,
  /** Intervalo entre atualizações do progresso fake. */
  tickMs: 200,
  /** Incremento mínimo visível por tick (%). */
  minIncrementPerTick: 1,
  /** Fração do restante até o teto — desacelera perto do limite. */
  incrementFactor: 0.14,
  /**
   * Fração da fatia da etapa atual em sync que o fake pode preencher
   * antes da conclusão real (ex.: 3 itens, nenhum pronto → até ~33%).
   */
  inProgressFillRatio: 0.92
} as const
